<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area foot">
      <div class="tit_area">
        <div class="sub_tit">이메일 주소 무단 수집 거부</div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="tit_h5">
        한국오션플랫폼 홈페이지는 이메일 주소 수집을 거부합니다.
      </div>
      <div class="sub_cont_txt" v-if="device === 'mo'">
        사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적
        장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시
        「정보통신망 이용촉진 및 정보보호 등에 관한 법률」제50조의 2에 의거하여
        형사 처벌됨을 유념하시기 바랍니다.<br />또한 당사의 사전 허락 없이
        이메일 제목에 ’한국오션플랫폼’ 문구를 사용하거나 한국오션플랫폼이 보낸
        것으로 오해하도록 작성한 이메일 발송 시에도 법적 조치를 취할 것임을
        알려드립니다.
      </div>
      <div class="sub_cont_txt mgt40" v-else>
        본 사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의
        기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시
        <br />「정보통신망 이용촉진 및 정보보호 등에 관한 법률」제50조의 2에
        의거하여 형사 처벌됨을 유념하시기 바랍니다. 또한 당사의 사전 허락 없이
        <br />이메일 제목에 ’한국오션플랫폼’ 문구를 사용하거나 한국오션플랫폼이
        보낸 것으로 오해하도록 작성한 이메일 발송 시에도 법적 조치를 취할 것임을
        알려드립니다.
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';

export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
